import * as Icons from '@/icons';

import type { JSXElementConstructor } from 'react';

export const iconTransformer = (
  icon: keyof typeof Icons
): JSXElementConstructor<Icons.IconType> => Icons[icon] ?? null;
